/* MIYAGEN 汎用カウントダウン (2026-06-18)
   発売予約(発売まで) / 抽選(抽選終了まで) のカード・バナー共通タイマー。
   対象: [data-miy-countdown] 要素。属性:
     data-closes-at   ISO日時(必須)。終了時刻。
     data-cd-expired  終了時に表示するテキスト(任意, 既定「まもなく」)。
     data-cd-reload   "1" のとき終了時に一度だけ location.reload()(任意。商品ページのバナー用)。
   要素のテキストには残り時間「N日 HH:MM:SS」を1秒ごとに書き込む(ラベルは呼び出し側で付与)。
   ※商品ページの抽選バナー(miyagen-raffle-banner)は独自スクリプト([data-raffle-countdown])のままで重複しない。 */
(function () {
  if (window.__miyagenCountdownInit) return;
  window.__miyagenCountdownInit = true;

  function two(n) { return (n < 10 ? '0' : '') + n; }

  function fmt(diff) {
    var s = Math.floor(diff / 1000);
    var d = Math.floor(s / 86400); s -= d * 86400;
    var h = Math.floor(s / 3600); s -= h * 3600;
    var m = Math.floor(s / 60); s -= m * 60;
    return (d > 0 ? d + '日 ' : '') + two(h) + ':' + two(m) + ':' + two(s);
  }

  function tick() {
    var els = document.querySelectorAll('[data-miy-countdown]');
    if (!els.length) return;
    var now = Date.now();
    els.forEach(function (el) {
      if (el.__miyDone) return;
      var iso = el.getAttribute('data-closes-at');
      var end = Date.parse(iso);
      if (isNaN(end)) { el.textContent = ''; return; }
      var diff = end - now;
      if (diff <= 0) {
        el.__miyDone = true;
        el.textContent = el.getAttribute('data-cd-expired') || 'まもなく';
        if (el.getAttribute('data-cd-reload') === '1') {
          try {
            var k = 'miyagen_cd_expired_' + iso;
            if (!sessionStorage.getItem(k)) {
              sessionStorage.setItem(k, '1');
              setTimeout(function () { window.location.reload(); }, 2000);
            }
          } catch (e) {}
        }
        return;
      }
      el.textContent = fmt(diff);
    });
  }

  tick();
  setInterval(tick, 1000);
})();
